import { Box } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import TableChartIcon from '@mui/icons-material/TableChart';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { SUBMISSION_FILE_TYPE_COLOR, SubmissionFileType } from '../../../model/ser/ser-enums';

const ICONS: Record<SubmissionFileType, typeof PictureAsPdfIcon> = {
    [SubmissionFileType.Pdf]: PictureAsPdfIcon,
    [SubmissionFileType.Imagem]: ImageIcon,
    [SubmissionFileType.Excel]: TableChartIcon,
    [SubmissionFileType.Word]: DescriptionIcon,
};

// Ícone do arquivo em um quadrado com a cor do tipo (PDF vermelho, Word azul, Excel verde, Imagem laranja)
export function FileTypeIcon({ type, size = 40 }: { type?: number; size?: number }) {
    const Icon = ICONS[type as SubmissionFileType] ?? InsertDriveFileIcon;
    const color = SUBMISSION_FILE_TYPE_COLOR[type as SubmissionFileType] ?? '#757575';
    return (
        <Box
            sx={{
                width: size, height: size, flexShrink: 0, borderRadius: 1.5,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color, bgcolor: `${color}14`,
            }}
        >
            <Icon sx={{ fontSize: size * 0.55 }} />
        </Box>
    );
}
